export type TranslationValue =
  | string
  | TranslationTree
  | ReadonlyArray<string | Record<string, string>>
  | Array<string | Record<string, string>>;

/** Structural shape for translation trees (open index for nesting). */
export type TranslationTree = { [key: string]: TranslationValue };

export type BilingualTranslations = { da: TranslationTree; en: TranslationTree };

/**
 * Identity helper that checks a tree against {@link TranslationTree} while
 * preserving literal key types (unlike `: TranslationTree` annotations).
 */
export function defineTranslationTree<const T extends TranslationTree>(tree: T): T {
  return tree;
}

/**
 * Same as {@link defineTranslationTree} for `{ da, en }` bundles so
 * `keyof typeof bundle.da` stays concrete.
 */
export function defineBilingualTranslations<
  const Da extends TranslationTree,
  const En extends TranslationTree,
>(bundle: { da: Da; en: En }): { da: Da; en: En } {
  return bundle;
}

/** Resolve a flat translation key to a string (falls back to the key). */
export function resolveTranslationString(tree: TranslationTree, key: string): string {
  const value = tree[key];
  return typeof value === "string" ? value : key;
}
